import { useContext, memo } from "react";
import { BrowserContext } from "../services/BrowserContext";
import ContentActionMenu from "../ContentActionMenu";
import ItemName from "../ItemName";

const Folder = (props) => {
    const {handleCurrentPath} = useContext(BrowserContext);
    let path = Array.from(props.path);
    path.push(props.name);

    return (
        <button className="list-group-item list-group-item-action justify-content-between d-flex align-items-center" onDoubleClick={(e)=> handleCurrentPath(path)}>
            <div className="d-flex align-items-center flex-grow-1">
                <span style={{position:'relative', display:'inline-flex', alignItems:'center'}}>
                    <i className="bi bi-folder-fill text-warning"></i>
                    {props.shared && <i className="bi bi-share-fill text-primary" style={{fontSize:'0.70rem', position:'absolute', bottom:'7px', right:'15px'}}></i>}
                </span>
                <ItemName {...props}></ItemName>
            </div>
            <ContentActionMenu name={props.name} path={props.path} shared={props.shared} shareToken={props.shareToken} shareExpiresAt={props.shareExpiresAt}/>
        </button>
    )
}

export default memo(Folder)
